import React from "react";
import { StyleSheet, Dimensions } from "react-native";
import Metrics from "../../constants/metrics";
import colors from "../../constants/color";

const { height, width } = Dimensions.get("window");

export default StyleSheet.create({
  containerPadding: {
    minHeight: 66,
    backgroundColor: colors.white,
    shadowColor: "rgba(0, 0, 0, 1)",
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowRadius: 5,
    shadowOpacity: 0.8,
    elevation: 3,
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  transParentClass: {
    padding: Metrics.margin2,
    height: 66,
    backgroundColor: "transparent",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    position: "absolute",
    width: "100%",
    top: 0,
  },
  customerHeaderTitle: {
    fontSize: 20,
  },
  rightIconDropdownView: {
    position: "absolute",
    right: 0,
    minWidth: 40,
    height: "100%",
  },
  dropdownView: {
    zIndex: 500,
    position: "relative",
    marginRight: 16,
    minWidth: 140,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 12,
    },
    shadowOpacity: 0.58,
    shadowRadius: 16.0,
    elevation: 3,
    paddingHorizontal: 16,
    paddingVertical: 10,
    backgroundColor: colors.white,
  },
});
